import api from "./Api";

class GerenciadorNFeService {
  ConsultarStatusServico(payload) {
    return api
      .get("/v1/GerenciadorNFe/ConsultarStatusServico" + payload)
      .then((response) => {
        return response.data;
      });
  }

  ConsultarStatusNota(payload) {
    return api
      .get("/v1/GerenciadorNFe/ConsultarStatusNota?chave=" + payload)
      .then((response) => {
        return response.data;
      });
  }

  TransmitirNota(payload) {
    return api
      .get("/v1/GerenciadorNFe/TransmitirNota?nota=" + payload)
      .then((response) => {
        return response.data;
      });
  }

  CancelarNota(payload) {
    return api
      .get(
        "/v1/GerenciadorNFe/CancelarNota?nota=" +
          payload.id +
          "&justificativa=" +
          payload.justificativa
      )
      .then((response) => {
        return response.data;
      });
  }

  InutilizarNFe(payload) {
    return api
      .get("/v1/GerenciadorNFe/InutilizarNFe?id=" + payload)
      .then((response) => {
        return response.data;
      });
  }

  TransmitirCCeNFe(payload) {
    return api
      .get("/v1/GerenciadorNFe/TransmitirCCeNFe?id=" + payload)
      .then((response) => {
        return response.data;
      });
  }

  ImprimirNFe(payload) {
    return api
      .get("/v1/GerenciadorNFe/ImprimirNFe/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  PrevisualizarNFe(payload) {
    return api
      .get("/v1/GerenciadorNFe/PrevisualizarNFe/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  ImprimirCCe(payload) {
    return api
      .get("/v1/GerenciadorNFe/ImprimirCCe/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  CorrigirDuplicidadeNFe(payload) {
    return api
      .get("/v1/GerenciadorNFe/CorrigirDuplicidadeNFe?nota=" + payload)
      .then((response) => {
        return response.data;
      });
  }

  DownloadXMLNFe(payload) {
    return api
      .get("/v1/GerenciadorNFe/DownloadXMLNFe?id=" + payload)
      .then((response) => {
        return response.data;
      });
  }

  GetXMLDownload(payload) {
    return api.get("/v1/GerenciadorNFe/GetXMLDownload").then((response) => {
      return response.data;
    });
  }

  DownloadDiretorio(payload) {
    return api
      .get("/v1/GerenciadorNFe/DownloadDiretorio?anomes=" + payload)
      .then((response) => {
        return response.data;
      });
  }

  DownloadDiretorioPeriodo(payload) {
    return api
      .get("/v1/GerenciadorNFe/DownloadDiretorioPeriodo", {
        params: payload,
      })
      .then((response) => {
        return response.data;
      });
  }
}

export default new GerenciadorNFeService();
